export const Networks = {
  1: "Mainnet",
  3: "Ropsten Test",
  5: "Goerli Test",
  11155111: "Sepolia",
};

export const networkName = {
  1: "mainnet",
  3: "ropsten",
  5: "goerli",
  11155111: "sepolia",
};

export const isMainnet = (networkId) => {
  return String(networkId) === String(1);
};
